export default __webpack_public_path__ + "static/media/step-6.219f87cf.png";